import { useFormik } from 'formik'
import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import SaveButton from '../../components/buttons/SaveButton'
import * as Yup from 'yup';
import { updateLink } from '../../redux/slice/UpdateLink'
import { toast } from 'react-toastify'

export default function UpdateLink(props) {
    const { show, setShow, bool, setBool, linkItem } = props
    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const linkSchema = Yup.object({
        long_url: Yup.string().required('URL is required')
    });

    const initialValues = {
        id: linkItem ? linkItem._id : "",
        long_url: linkItem ? linkItem.long_url : "",

    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: linkSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true);
            dispatch(updateLink(values)).then((res) => update_res(res.payload));
        }
    });

    const update_res = (res) => {
        if (res?.data?.status == true) {
            toast.success('Update successful...!!', { position: "bottom-right" });
            setSpinner(false);
            setShow(false);
            setBool(!bool);
        } else {
            toast.error(res?.data?.message, { position: "bottom-right" });
            setSpinner(false);
        }
    }

    return (
        <>
            <Modal
                size="md"
                show={show}
                centered
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-md"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">
                        Update Link
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <label htmlFor="longUrl" className="form-label">
                            Long URL <span className="text-danger">*</span>
                        </label>
                        <textarea
                            className="form-control form_input"
                            rows="4"
                            name='long_url'
                            value={values.long_url}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter the long URL"
                        // disabled={spinner}
                        />
                        {errors.long_url && touched.long_url ? (<span className='text-danger form_label'>{errors.long_url}</span>) : null}

                        <div className='text-end mt-3'>
                            <SaveButton
                                spinner={spinner}
                                button_name={'UPDATE LINK'}
                            />
                        </div>
                    </Form>
                </Modal.Body>

            </Modal>
        </>
    )
}
